"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureAudoUpdate = exports.performUpdate = void 0;
const firebase_app_1 = __importDefault(require("common/firebase-app"));
const firestore_1 = require("firebase/firestore");
const semver_1 = require("semver");
require("react-router-dom");
const firestore = (0, firestore_1.getFirestore)(firebase_app_1.default);
let isUpdateAvailable = false;
const getAvailableVersion = () => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield fetch("/version.json");
    const result = yield response.json();
    const { appVersion: availableAppVersion } = result;
    return availableAppVersion;
});
const performUpdate = (force = false) => {
    if (!isUpdateAvailable)
        return;
    const confirmed = force ||
        window.confirm("新しいバージョンが利用可能になり、このバージョンは動作保証外となりました。すぐにリロードして更新しますか？");
    if (confirmed) {
        window.location.reload();
    }
};
exports.performUpdate = performUpdate;
const configureAudoUpdate = (currentAppVersion) => {
    (0, firestore_1.onSnapshot)((0, firestore_1.doc)(firestore, "version/default"), (doc) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        console.log("version updated", doc.data());
        const requiredAppVersion = (_a = doc.data()) === null || _a === void 0 ? void 0 : _a["requiredAppVersion"];
        const preferredVersion = (_b = doc.data()) === null || _b === void 0 ? void 0 : _b["preferredVersion"];
        if (preferredVersion && !(0, semver_1.satisfies)(currentAppVersion, preferredVersion)) {
            const availableAppVersion = yield getAvailableVersion();
            if ((0, semver_1.satisfies)(availableAppVersion, preferredVersion)) {
                isUpdateAvailable = true;
                console.log("New version is available.");
            }
            else {
                console.error("App version is not preferred version, but no new version is available.", {
                    currentAppVersion,
                    requiredAppVersion,
                    preferredVersion,
                });
            }
        }
        if (requiredAppVersion &&
            !(0, semver_1.satisfies)(currentAppVersion, requiredAppVersion)) {
            const availableAppVersion = yield getAvailableVersion();
            if ((0, semver_1.satisfies)(availableAppVersion, requiredAppVersion)) {
                isUpdateAvailable = true;
                (0, exports.performUpdate)(false);
            }
            else {
                console.error("App version is not satisfied with the requirement, but no new version is available.", {
                    currentAppVersion,
                    requiredAppVersion,
                    availableAppVersion,
                });
            }
        }
    }));
    console.log("current app version: ", currentAppVersion);
};
exports.configureAudoUpdate = configureAudoUpdate;
